import { v4 as uuidv4 } from 'uuid';
import {
  ActionTargetStepModel,
  Identified,
  LocalizedValueModel,
  Named,
} from '../..';
import { WorkflowActionDialogOptionsModel } from './workflow-action-dialog-options.model';

export class ConditionActionStepTarget {
  order: number;
  condition: string;
  targetStep: ActionTargetStepModel;
}

export class WorkflowActionPresenterModel implements Identified<string>, Named {
  id: string;
  name: LocalizedValueModel;
  description: LocalizedValueModel;
  isMainAction: boolean;
  dialogOptions?: WorkflowActionDialogOptionsModel;
  targetStep: ActionTargetStepModel;
  conditionalTargetSteps?: ConditionActionStepTarget[];
  message?: {
    enabled?: boolean;
    value?: LocalizedValueModel;
  };
  visible?: { enabled: boolean; expression?: string };
}
